module.exports = __webpack_public_path__ + "img/google_pay.png";